import { useChangePartnershipTierModal } from "@pallet/features/PartnershipType/ChangePartnershipTierModal/hooks"
import { useBillingCycleSelect } from "@pallet/features/PartnershipTierType/BillingCycleSelector/hook"
import { Button, ButtonProps } from "@pallet-hq/hegel"
import mixpanel from "mixpanel-browser"
import { BUTTON_TYPES, TRACK_EVENTS } from "constants/events"
import { ChangePartnershipTierSelectorItemTierFragment } from "__generated__/ChangePartnershipTierSelectorItemTierFragment"
import { ChangePartnershipTierSelectorItemApplylistFragment } from "__generated__/ChangePartnershipTierSelectorItemApplylistFragment"

type ChangeTierButtonProps = {
    applylist: ChangePartnershipTierSelectorItemApplylistFragment
    partnershipTier: ChangePartnershipTierSelectorItemTierFragment
}

export const ChangeTierButton = (props: ChangeTierButtonProps) => {
    const { showModal } = useChangePartnershipTierModal()
    const { getItem } = useBillingCycleSelect()
    const item = getItem(props.partnershipTier)

    const handleClick = (action: "upgrade" | "downgrade" | "change plan") => {
        if (!item || !props.applylist.partnership) return null
        showModal(item, props.applylist.partnership, action)
        mixpanel.track(TRACK_EVENTS.COLLECTIVE_TIER_SELECTED, {
            type: BUTTON_TYPES.CHANGE_PLAN,
            applylist_slug: props.applylist.slug,
            subscription_length: item?.recurringEnum,
            action: action,
        })
    }

    let cta: string
    let disabled = false
    let variant: ButtonProps["variant"] = "secondary"
    let action: "upgrade" | "downgrade" | "change plan"
    const currentPlan = props.applylist.partnership?.price
    if (item && currentPlan?.stripeId === item.price?.stripeId) {
        disabled = !(
            props.applylist.partnership &&
            props.applylist.partnership.canRepurchase
        )
        cta = "Current plan"
        variant = "primary"
    } else {
        const itemPrice = item?.price?.monthlyUnitAmount ?? 0
        const currentPrice = currentPlan?.monthlyUnitAmount ?? 0
        if (itemPrice < currentPrice) {
            cta = "Downgrade"
            action = "downgrade"
        } else if (itemPrice > currentPrice) {
            cta = "Upgrade"
            variant = "primary"
            action = "upgrade"
        } else {
            cta = "Change plan"
            action = "change plan"
        }
    }

    return (
        <Button
            variant={variant}
            size="small"
            mt="small"
            width="100%"
            onClick={() => handleClick(action)}
            disabled={disabled || !!props.applylist.canEdit}
        >
            {cta}
        </Button>
    )
}
